import { FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'react-recompose';
import { Input, Button, Select, Switch } from 'antd';
import { Refresh, ArrowDropDown, Search } from '@material-ui/icons';

const { Option } = Select;

function ShippingCostFilter({
  intl,
  searchText,
  onSearch,
  onSearchDayPart,
  onKeyDownSearch,
  onApplyFilter,
  onToggle,
  checkAvailable,
}) {
  const handleSearch = e => {
    onSearch(e);
  };

  const handleSearchDayPart = e => {
    onSearchDayPart(e);
  };

  const dayPartState = [
    { value: '06:00,10:59', label: intl.formatMessage({ id: 'breakfast' }) },
    { value: '11:00,14:59', label: intl.formatMessage({ id: 'lunch' }) },
    { value: '15:00,16:59', label: intl.formatMessage({ id: 'snack 1' }) },
    { value: '17:00,20:59', label: intl.formatMessage({ id: 'dinner' }) },
    { value: '21:00,22:59', label: intl.formatMessage({ id: 'snack 2' }) },
    { value: '00:00,03:59', label: intl.formatMessage({ id: 'extended evening hours' }) },
    { value: '04:00,05:59', label: intl.formatMessage({ id: 'extended breakfast time' }) },
    { value: '', label: intl.formatMessage({ id: 'All' }) },
  ];

  return (
    <div className="shippingCost_filter_layout">
      <Select
        className="day_part"
        suffixIcon={<ArrowDropDown />}
        placeholder={intl.formatMessage({ id: 'Select a Part time' })}
        onChange={e => handleSearchDayPart(e)}
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
        getPopupContainer={trigger => trigger.parentNode}
      >
        {dayPartState.map(day => (
          <Option key={day.value} value={day.value}>
            {day.label}
          </Option>
        ))}
      </Select>

      <Button className="apply_filters_btn" onClick={onApplyFilter}>
        <FormattedMessage id="Apply filters" />
        <Refresh />
      </Button>
      <div className="isEnableAll">
        <FormattedMessage id="enable all" />
        <Switch checked={checkAvailable} onChange={onToggle} />
      </div>
      <Input
        suffix={<Search />}
        inputMode="numeric"
        placeholder={intl.formatMessage({ id: 'Search by id' })}
        value={searchText}
        onChange={e => handleSearch(e)}
        onKeyDown={e => {
          if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
            e.preventDefault();
          }
          onKeyDownSearch(e);
        }}
      />
    </div>
  );
}

export default compose(injectIntl)(ShippingCostFilter);
